import mixpanel from 'mixpanel-browser';
import { isProductionHost } from '../commonFunctions';
import { mixpanelProdToken, mixpanelDevToken } from '../constants';
import { MixpanelChatUserType } from '../models/commonTypeScript';

if (isProductionHost) {
    mixpanel.init(mixpanelProdToken);
} else {
    mixpanel.init(mixpanelDevToken);
}

export const analyticsLogger = <T>(eventName: string, eventData: T): void => {
    mixpanel.track(eventName, eventData);
};

export const mixpanelRegisterSuperProperties = <T>(eventData: T): void => {
    mixpanel.register(eventData);
};

export const mixpanelReset = (): void => {
    // Clears super properties, distinct_id, and opt-out status
    try {
        mixpanel.reset();
    } catch (_) {
        // ignore if mixpanel not available
    }
};

export const mixpanelClearOrgContext = (): void => {
    // Ensure previous org context is removed when switching to Consumer or another org
    try {
        mixpanel.unregister('organization');
        mixpanel.unregister('organizationId');
        mixpanel.unregister('groupId');
        mixpanel.unregister('role');
        mixpanel.unregister('managedBy');
        mixpanel.unregister('name');
    } catch (e) {
        // ignore
    }
};

export const mixpanelChatInformation = (user: MixpanelChatUserType, groups: string[], userIsHbs: boolean): void => {
    mixpanel.people.set({
        $email: user.email,
        organizations: groups,
        $name: user.name,
        isBusinessUser: userIsHbs,
    });

    mixpanel.identify(user.user_id);
};

export enum PageType {
    Insight = 'Insight',
    Device = 'Device',
    Account = 'Account',
    PublicDashboard = 'Public Dashboard',
    Building = 'Building',
    Floorplan = 'Floorplan',
    Dashboard = 'Dashboard',
    Alert = 'Alert',
    Integration = 'Integration',
    Status = 'Status',
    Customers = 'Customers',
}

export enum ReportType {
    Outdoor = 'Outdoor',
    Pressure = 'Pressure',
    Radon = 'Radon',
    VirusRisk = 'Virus Risk',
    IAQCertificate = 'IAQ certificate',
    EnergyWastage = 'Energy Wastage',
    IAQInsight = 'IAQ Insight',
    Calibration = ' Calibration report',
    WELLReport = 'WELL Report',
}

export enum FeatureType {
    MoldRisk = 'Mold risk',
    Occupancy = 'Occupancy',
    VirusRisk = 'Virus risk',
}

export enum IntegrationType {
    ThirdParty = 'Third Party',
    API = 'API',
    Webhooks = 'Webhooks',
    MQTT = 'MQTT',
    MCP = 'MCP',
}
